// src/config/flags.js

// 🚀 Toggle testing mode globally, or set via environment variable (.env)
export const IN_TESTING = process.env.REACT_APP_IN_TESTING === 'true' || true;